import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { TFunction } from 'i18next';

export const exportProductQuantityExcel = async (
  t: TFunction,
  products: any[],
  StoresTextMap: Record<string, string>,
  branches: string[]
) => {
  const now = new Date();
  const formattedDate = `${now.getFullYear()}${String(
    now.getMonth() + 1
  ).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet();

  const baseColumns = [
    { header: t('Category'), key: 'category_name' },
    // { header: t('Item ID'), key: 'code' ,style: { numFmt: '@' }}, //? text format
    // { header: t('Item ID'), key: 'code', style: { numFmt: '0000000' } },
    { header: t('Item ID'), key: 'code' },
    { header: t('Barcode ID'), key: 'barcode' },
    { header: t('Item Name'), key: 'name' },
  ];

  const branchColumns = branches.map((branchId) => ({
    header: StoresTextMap[branchId] || branchId,
    key: `branch_${branchId}`,
    style: { numFmt: '#,##0.00' },
  }));

  const totalColumn = {
    header: t('Total Quantity'),
    key: 'total',
    style: { numFmt: '#,##0.00' },
  };

  worksheet.columns = [...baseColumns, ...branchColumns, totalColumn];

  products.forEach((product, _index) => {
    const rowData: any = {
      category_name: product.category_name,
      // code: String(product.code).padStart(7, '0'), //? text format
      code: product.code,
      barcode: product.barcode,
      name: product.name,
    };

    branches.forEach((branchId) => {
      const branchData = product.quantity_by_branch?.find(
        (b: any) => String(b.store_id) === branchId
      );
      const qty = branchData?.quantity ?? 0;
      rowData[`branch_${branchId}`] = qty;
    });

    // Add row to worksheet
    const row = worksheet.addRow(rowData);

    const branchStartCol = baseColumns.length + 1;
    const branchEndCol = branchStartCol + branches.length - 1;
    const totalCol = branchEndCol + 1;

    const excelRowNumber = row.number;

    const startColLetter = worksheet.getColumn(branchStartCol).letter;
    const endColLetter = worksheet.getColumn(branchEndCol).letter;

    const totalCell = worksheet.getCell(
      `${worksheet.getColumn(totalCol).letter}${excelRowNumber}`
    );
    totalCell.value = {
      formula: `SUM(${startColLetter}${excelRowNumber}:${endColLetter}${excelRowNumber})`,
    };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `export_stock_items_${formattedDate}.xlsx`);
};
